import {
	ToothEndodonticPain,
	ToothEndodonticTest,
	ToothEndodonticTestResult,
	ToothEndodonticTestResultNotApplicable,
	ToothEndodonticTestResultPositive,
} from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';

export type EndodonticValue =
	| ToothEndodonticPain
	| ToothEndodonticTest
	| null
	| number;
type EndodonticMapValue =
	| ToothEndodonticTestResult
	| ToothEndodonticTestResultNotApplicable
	| ToothEndodonticTestResultPositive
	| ToothEndodonticPain;

const ENDODONTIC_VALUE_MAP: Record<EndodonticMapValue, string> = {
	[ToothEndodonticTestResult.Uncertain]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.uncertain',
	[ToothEndodonticTestResult.Negative]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.negative',
	[ToothEndodonticTestResult.Positive]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.positive',
	[ToothEndodonticTestResult.NotApplicable]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.notApplicable',
	[ToothEndodonticTestResultNotApplicable.PreviouslyInitiatedTherapy]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.previouslyInitiatedTherapy',
	[ToothEndodonticTestResultNotApplicable.ExistingRootCanalTreatment]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.existingRootCanalTreatment',
	[ToothEndodonticTestResultPositive.WithinLimits]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.withinLimits',
	[ToothEndodonticTestResultPositive.PainStimulus]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painStimulus',
	[ToothEndodonticTestResultPositive.PainLingering]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painLingering',
	[ToothEndodonticPain.Unpleasant]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.unpleasant',
	[ToothEndodonticPain.NotPainful]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.notPainful',
	[ToothEndodonticPain.Painful]:
		'patientTreatment.meddiDENT.dentalCross.endodontic.painful',
};

export default function parseEndodonticValue(value: EndodonticValue) {
	const { t } = useTranslation();

	if (!value) {
		return t('patientTreatment.meddiDENT.history.text.endodonticTestReset');
	}

	switch (typeof value) {
		case 'number':
			return value;
		case 'string':
			return t(ENDODONTIC_VALUE_MAP[value]);
		default:
			return Object.values(value)
				.map(val => t(ENDODONTIC_VALUE_MAP[val]))
				.filter(Boolean)
				.join(', ');
	}
}
